import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const EditDeliveryPersonModal = ({ show, onClose, onSave, delivery }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleEdit = () => {
    if (!validate()) return;

    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
    };

    onSave(payload);
  };

  useEffect(() => {
    if (show && delivery) {
      setFormData({
        name: delivery.name || "",
        email: delivery.email || "",
        phone: delivery.phone || "",
      });
    }
  }, [delivery, show]);
  const isChanged = () => {
    if (!delivery) return false;
    return (
      formData.name !== delivery.name ||
      formData.email !== delivery.email ||
      formData.phone !== delivery.phone
    );
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\+?\d{10,15}$/.test(formData.phone)) {
      newErrors.phone = "Phone number is invalid";
    }

    if (
      !formData.phone ||
      formData.phone === "+251" ||
      formData.phone.length <= 4
    ) {
      newErrors.phone = "Phone number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  if (!show) return null;

  return (
    <div
      className="modal  show  overflow-y-auto"
      style={{ display: "block", marginTop: "70px", height: "600px" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-light">
          <div className="modal-header">
            <h5 className="modal-title text-light">Edit Delivery Person</h5>
            <button
              type="button"
              className="btn-close btn-close-light"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="mb-2 col-12 col-md-6">
                <label className="form-label text-light">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`form-control  ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter name"
                  style={{
                    borderColor: "#3f5263",
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
                {errors.name && (
                  <div className="invalid-feedback" style={{ color: "red" }}>
                    {errors.name}
                  </div>
                )}
              </div>
              <div className="mb-3 text-start col-12 col-md-6">
                <label className="form-label">Phone</label>

                <div style={{ position: "relative", width: "100%" }}>
                  <img
                    src="https://flagcdn.com/et.svg"
                    alt="Ethiopia"
                    style={{
                      width: "24px",
                      height: "16px",
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />

                  <span
                    style={{
                      position: "absolute",
                      left: "40px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "1rem",
                      color: "black",
                      userSelect: "none",
                    }}
                  >
                    +251
                  </span>

                  <input
                    type="tel"
                    maxLength={9}
                    value={formData.phone.replace("+251", "")}
                    className={`form-control ${
                      errors.phone ? "is-invalid" : ""
                    }`}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\D/g, "");
                      setFormData((prev) => ({ ...prev, phone: `+251${raw}` }));
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    }}
                    placeholder="911 234 567"
                    style={{
                      width: "100%",
                      height: "40px",
                      paddingLeft: "90px",
                      fontSize: "1rem",
                      border: "2px solid #3f5263",
                      borderRadius: "0.375rem",
                      outline: "none",
                    }}
                  />
                </div>

                {errors.phone && (
                  <div
                    className="invalid-feedback d-block mt-1"
                    style={{ color: "red" }}
                  >
                    {errors.phone}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-2">
              <label className="form-label text-light">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control  ${errors.email ? "is-invalid" : ""}`}
                placeholder="Enter email"
                style={{
                  borderColor: "#3f5263",
                  outline: "none",
                  boxShadow: "none",
                }}
              />
              {errors.email && (
                <div className="invalid-feedback " style={{ color: "red" }}>
                  {errors.email}
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-light text-info" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleEdit}
              disabled={!isChanged()}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDeliveryPersonModal;
